import type { Ref } from 'vue'

import { useUtil } from '@/composables/util'
import store from '@/store'

/**
 * Returns a function that sets `owner` to the current user's username for non-staff users
 * (staff may pick the owner, so their selection is left alone).
 */
export function useDefaultOwner(owner: Ref<string | undefined>): () => void {
  const { isStaff } = useUtil()

  return () => {
    if (!isStaff()) {
      owner.value = store.getters.user.userUsername
    }
  }
}
